<script>
  export default {
    components: { },
    data() {
      return {
      }
    },
    methods: {
        verificarPagamento() {
            this.$router.push({
                name: 'transparencia.institucional.detalhar',
            });
        },
    },
    computed: {
    },
    mounted() {
    }
  }
</script>

<template>
    <div>
        <div class="ibox float-e-margins">
            <div class="ibox-title">
                <h4><b>Institucional</b></h4>
            </div>

            <div class="ibox-content">
                <button class="btn btn-primary" type="button" @click="verificarPagamento()">
                    <i class="fa fa-search"></i> Verificação de Pagamento
                </button>
            </div>
        </div>
        <router-view></router-view>
    </div>

</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/transparencia/componentes/compartilhado/institucional/Institucional.vue